import React, { useState } from "react";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import Typography from "@mui/material/Typography";
import { BusinessNavItem } from "./BusinessNavItem";
import { ResourceNavItem } from "./ResourceNavItem";
import { FeelGreatCoachingNavItem } from "./FeelGreatCoachingNavItem";
import { getBusinessDrawerItems, getResourceDrawerItems } from "./nav-drawer-items";
import { CopyrightSection } from "../CopyrightSection";
import { useAuth } from "../../hooks/useAuth";
import { ReactComponent as UnicityLogo } from "../../assets/icons/logo-unicity.svg";
import { ReactComponent as LogoOfficeIcon } from "../../assets/icons/logo-office.svg";
import { ReactComponent as CloseIcon } from "../../assets/icons/close-icon.svg";

const MobileNavDrawer = ({ drawerOpen, toggleDrawer, shopLink }) => {
  const [drawerWidth, setDrawerWidth] = useState(240);
  const { userInfo } = useAuth();
  const businessItems = getBusinessDrawerItems(userInfo?.isAffiliate);
  const resourceItems = getResourceDrawerItems(userInfo?.isAffiliate);

  const subheaderStyle = {
    fontFamily: "Inter",
    fontWeight: 600,
    fontSize: 10,
    color: "#8A9BB0",
    mb: 2,
    mt: 2,
    ml: 1,
  };

  return (
    <div>
      <Drawer open={drawerOpen} onClose={toggleDrawer}>
        <Box
          id="nav-drawer"
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            width: drawerWidth,
            height: "100vh",
            pl: "16px",
            pr: "16px",
            pt: "26px",
          }}
        >
          <Box>
            <Box
              sx={{
                display: "flex",
                gap: "20px",
                mb: "42px",
                alignItems: "center",
              }}
            >
              <Box
                onClick={toggleDrawer}
                aria-label="close navigation"
                sx={{ cursor: "pointer" }}
              >
                <CloseIcon className="close-icon" />
              </Box>
              <Box sx={{ display: "flex", gap: "6.5px", alignItems: "center" }}>
                <UnicityLogo
                  className="unicity-logo"
                  aria-label="Unicity Logo"
                  style={{ width: "87px" }}
                />
                <LogoOfficeIcon className="unicity-logo-office" />
              </Box>
            </Box>
            <Box>
              <Typography sx={subheaderStyle}>BUSINESS</Typography>
            </Box>
            <Box>
              {businessItems.map((item, index) => {
                return (
                  <BusinessNavItem
                    key={index}
                    item={item}
                    drawerOpen={drawerOpen}
                    toggleDrawer={toggleDrawer}
                    isMobile={true}
                  />
                );
              })}
              <FeelGreatCoachingNavItem
                isMobile={true}
                drawerOpen={drawerOpen}
                toggleDrawer={toggleDrawer}
              />
            </Box>
            <Box>
              <Typography sx={subheaderStyle}>RESOURCES</Typography>
            </Box>
            {resourceItems.map((item, index) => (
              <ResourceNavItem
                key={index}
                item={item}
                drawerOpen={drawerOpen}
                isMobile={true}
                setDrawerWidth={setDrawerWidth}
                shopLink={shopLink}
              />
            ))}
          </Box>
          <Box>
            <CopyrightSection padding={1.5} />
          </Box>
        </Box>
      </Drawer>
    </div>
  );
};

export { MobileNavDrawer };
